import {PinyinInline,PinyinText} from './pinyin-text';

export type GrammarCopyPart = string | {hanzi:string;pinyin:string};

// Readings belong to authored presentation data, never inferred from glyphs.
export function GrammarRuleCopy({text,parts}:{text:string;parts?:GrammarCopyPart[]}) {
 if(!parts)return <PinyinInline text={text}/>;
 // Keep closing punctuation with its Chinese phrase instead of an orphan line.
 const display:GrammarCopyPart[]=[];
 for(const part of parts){const previous=display.at(-1),punctuation=typeof part==='string'?/^[。？！?!.,，]+/.exec(part)?.[0]:undefined;
  if(typeof part==='string'&&punctuation&&previous&&typeof previous!=='string'){display[display.length-1]={...previous,hanzi:previous.hanzi+punctuation};if(part.length>punctuation.length)display.push(part.slice(punctuation.length));}
  else display.push(part);
 }
 return <>{display.map((part,index)=>typeof part==='string'
  ? <PinyinInline key={index} text={part}/>
  : <span className="grammar-rule-fragment" key={index}><span className="hz" lang="zh-Hans">{part.hanzi}</span><PinyinText text={part.pinyin}/></span>)}</>;
}
